/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { DraftFulfillment } from './draftFulfillment';
import {
  ItemPrice,
  ItemPriceData,
} from './itemPrice';
import {
  Product,
  ProductData,
} from './product';
import { ProductVariant } from './productVariant';

export interface DraftOrderItemData {
  id: string;

  // The product variant of the line item
  variant: {
    // ID that identifies the variant
    id: string;

    // Product that contains the variant
    product: ProductData;
  };

  price: ItemPriceData;

  quantity: number;
}

export class DraftOrderItem {
  public readonly variant: ProductVariant;
  public readonly fulfillment?: DraftFulfillment;
  public readonly price: ItemPrice;

  constructor(
    currency: string,
    private data: DraftOrderItemData,
  ) {
    const product = new Product(data.variant.product);
    const variant = product.variants.find((v) => (v.id === data.variant.id));
    if (!variant) {
      throw Error('variant is no longer available');
    }
    this.variant = variant;

    this.price = new ItemPrice(currency, data.price);
  }

  get id() { return this.data.id; }
  get quantity() { return this.data.quantity; }
}
